import React, { useState } from 'react'
import SignUpPage from './components/signForms/SignUpPage'
import SignInPage from './components/signForms/SignInPage'
import ProviderAuth from './components/ProviderAuth';
import Loading from "../../components/Loading";
import { NAME_PROJECT } from "../../settings/global";
import Page, { Block, Content } from "../../layouts/Content";
import styles from "./UserAuthLayout.module.scss";
import Breadcrumb, { BreadcrumbLayer } from "../../components/Breadcrumb";
import { SupportProviders } from "../homepage/SupportProviders";

function UserAuthLayout({clouds, authType}) {

    const [loading, setLoading] = useState(false);

    const renderContent = () => (
        <div className={styles["auth"]}>
            {
                loading &&
                <Loading
                    type='component-cover'
                    icon={{faCode: 'fas fa-chevron-up', animationType: 'top'}}
                    coverBorderRadius='var(--borderRadiusContainerInnerEdge)'
                />
            }
            <div className={styles['auth__fields']}>
                <p className={styles['auth__fields__title']}>{NAME_PROJECT} account</p>
                <div className={styles['auth__fields__content']}>
                    {
                        authType === 2
                            ? <SignUpPage setLoading={bool => setLoading(bool)} loading={loading}/>
                            : <SignInPage setLoading={bool => setLoading(bool)} loading={loading}/>
                    }
                </div>
            </div>
            <div className={styles['auth__separator']}/>
            <div className={styles['auth__providers']}>
                <p className={styles['auth__providers__title']}>Social provider</p>
                <div className={styles['auth__providers__content']}>
                    <ProviderAuth setLoading={setLoading} loading={loading}/>
                </div>
            </div>
        </div>
    )

    return (
        <Page backgroundColor='var(--colorBackgroundContent)'>
            <Block>
                <Breadcrumb>
                    <BreadcrumbLayer link='/' name='Home'/>
                    <BreadcrumbLayer name={`Sign ${authType === 2 ? 'Up' : 'In'}`}/>
                </Breadcrumb>
            </Block>
            <Block className={styles['sign']}>
                <Content className={styles['sign__container']}>
                    <h1 className={styles['sign__container__title']}>Sign {authType === 2 ? 'up' : 'in'} with</h1>
                    {renderContent()}
                </Content>
            </Block>
            <SupportProviders clouds={clouds}/>
        </Page>
    )
}

export default UserAuthLayout